export default __webpack_public_path__ + "static/media/org-members-approve.f0be10ed.png";